import CartItem from './cartitem.js';
import cartService from '../service/CartService.js';

export default class CartItemList extends React.Component {
  constructor() {
    super();

    this.state = {
      showmodal: false,
      modelitem: { id: 0, type: '0' },
      isLoaded: false,
      index: '0',
      items: [],
    };
  }

  componentWillMount() {
    var items = cartService.getCart();
    this.setState({
      isLoaded: true,
      items: items,
    });
  }

  keep_shopping = () => {
    window.location = __SiteUrl + 'course/listing';
  };

  removeFromCart = (item) => {
    cartService.removeItem(item.id, item.type).then((res) => {
      if (res) {
        this.setState({
          isLoaded: true,
          items: (_buyNow) ? {} : cartService.getCart(),
        });
        var count = 0,
          price = 0;
        for (var key of Object.keys(this.state.items)) {
          // if(this.state.items[key].others.discount_price != 0){
          // 	price = price+Number(this.state.items[key].others.discount_price);
          // }
          // else{
          price = price + Number(this.state.items[key].others.base_price);
          // }
          count++;
        }
        document.querySelector(".notitication-alert").innerHTML = count
        this.props.refresh(count, price, this.state.items, 'item_removed');
      } else {
        console.log('unable to delete');
      }
    });
  };
  refresh = () => {
    var price = 0;
    var count = 0;
    for (var key of Object.keys(this.state.items)) {
      price = price + Number(this.state.items[key].others.base_price);
      count++;
    }
    this.props.refresh(count, price, this.state.items);
  };
  render() {
    const { error, isLoaded, items } = this.state;
    
    if (error) {
      return <div>Error</div>;
    } else if (!isLoaded) {
      return (
        <div>
          <div className="cart-box">
            <div className="d-flex justify-content-between border-bottom">
              <div className="sm-d-block">
                <div className="cart-img">
                  <div
                    style={{ width: '178px', height: '104px' }}
                    className="eloads"
                  />
                </div>
                <div className="cart-text">
                  <div
                    className="eloads"
                    style={{ width: '230px', height: '20px' }}
                  />
                  <p
                    className="eloads"
                    style={{ width: '100px', marginTop: '5px', height: '14px' }}
                  />
                </div>
              </div>
              <div className="cart-price">
                <b
                  className="eloads"
                  style={{ width: '32px', height: '23px' }}
                />
                <span
                  className="eloads "
                  style={{ width: '32px', height: '20px' }}
                />
              </div>
            </div>
            <div className="d-flex justify-content-between w-100 cart-btm-bar">
              <div
                className="d-flex eloads trash-text"
                style={{ width: '57px', height: '28px' }}
              />
              <div
                className="applied-coupon d-flex eloads"
                style={{ width: '127px' }}
              />
            </div>
          </div>
          <div className="cart-box">
            <div className="d-flex justify-content-between border-bottom">
              <div className="d-flex sm-d-block">
                <div className="cart-img">
                  <div
                    style={{ width: '178px', height: '104px' }}
                    className="eloads"
                  />
                </div>
                <div className="cart-text">
                  <div
                    className="eloads"
                    style={{ width: '230px', height: '20px' }}
                  />
                  <p
                    className="eloads"
                    style={{ width: '100px', marginTop: '5px', height: '14px' }}
                  />
                </div>
              </div>
              <div className="cart-price">
                <b
                  className="eloads"
                  style={{ width: '32px', height: '23px' }}
                />
                <span
                  className="eloads "
                  style={{ width: '32px', height: '20px' }}
                />
              </div>
            </div>
            <div className="d-flex justify-content-between w-100 cart-btm-bar">
              <div
                className="d-flex eloads trash-text"
                style={{ width: '57px', height: '28px' }}
              />
              <div
                className="applied-coupon d-flex eloads"
                style={{ width: '127px' }}
              />
            </div>
          </div>
        </div>
      );
    } else {
      if (_buyNow) {
        return (
        <>
          <CartItem
            removeFromCart={this.removeFromCart}
            key={_buyNow}
            data={_buyNowDetails}
            refresh={this.refresh}
          />
          {_showMember == '1' ? (
            <p className="prime-notify-text">{_memberDefaultmsg}</p>
          ) : (
            ''
          )}
        </>);
      } else {
        return Object.keys(items).length ? (
          <div>
            {Object.keys(items).map((key, item) => (
              <>
                  <CartItem
                    couponappliedtrigger={this.props.couponappliedtrigger}
                    removeFromCart={this.removeFromCart}
                    key={key}
                    data={items[key]}
                    refresh={this.refresh}
                  /> 
              </>
            ))}
            <div class="col-md-8 pl-0">
              {(_buyNow == 0) ?
              (<button
                onClick={this.keep_shopping}
                class="btn add-course"
                href="#"
              >
                <svg
                  id="Group_2"
                  data-name="Group 2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="11.855"
                  height="11.855"
                  viewBox="0 0 11.855 11.855"
                >
                  <path
                    id="Path_16"
                    data-name="Path 16"
                    d="M3214,485.6v11.855"
                    transform="translate(-3208.073 -485.596)"
                    fill="none"
                    stroke="#2d71fd"
                    stroke-width="2"
                  ></path>
                  <path
                    id="Path_17"
                    data-name="Path 17"
                    d="M0,0V11.855"
                    transform="translate(11.855 5.928) rotate(90)"
                    fill="none"
                    stroke="#2d71fd"
                    stroke-width="2"
                  ></path>
                </svg>{' '}
                <span class="apply-text">Add Course</span>
              </button>) : ''}
              {_showMember == '1' ? (
                <p className="prime-notify-text">{_memberDefaultmsg}</p>
              ) : (
                ''
              )}
            </div>
          </div>
        ) : (
          <div></div>
        );
      }
    }
  }
}
